<template>
  <div class="guide-nav">
    <div
      :class="['item', { active: activeIndex.includes(item.path) }]"
      v-for="item in menuRoutes"
      :key="item.name"
      @click="toMenu(item)"
    >
      {{ item.meta.title }}
    </div>
  </div>
</template>

<script>

import menuRoutes from "@/router/menu";
import { deepClone } from "@/utils/index.js"
import path from 'path'
import { isExternal } from '@/utils/validate';

export default {
  data() {
    return {
      menuRoutes: deepClone(menuRoutes),
      onlyOneChild: null,
      activeIndex:this.$route.path,
      disabledPath:["/Documents/wiki","/Documents/Whitepaper","/Producers","/Explore/GitHub","/learn/QuickStart"],
      phoneMenuShow:false,
    };
  },
  methods: {
    handleSelect(data) {
      if(data == "/Documents/wiki"){
        setTimeout(() => {
          this.activeIndex = this.$route.path;
        },3000)
      }
      this.phoneMenuShow = false;
    },
    filterMenuRoute(menu, role = 9) {
      return menu.filter(i => {
        if (!i.children) {
          return i;
        } else if (i.children.length) {
          i.children = this.filterMenuRoute(i.children, role);
        }
      });
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    },
    toMenu(menu){
      this.$router.push(menu.path)
    }
  },
  created() {
    this.filterMenuRoute(this.menuRoutes)
  },
  watch:{
    $route(newVal){
      if(newVal.fullPath.indexOf("/TCashFinance") > -1){
        this.activeIndex = "/TCashFinance"
      }
      else if(newVal.fullPath.indexOf("/Governance") > -1){
        this.activeIndex = "/Governance"
      }
      else{
        this.activeIndex = newVal.path
      }
    }
  }
};
</script>
<style scoped lang="scss">
.guide-nav {
  font-family: DMSans-Medium, DMSans;
  font-weight: 500;
  display: flex;
  .item {
    font-size: 0.22rem;
    padding: 0 0.3rem;
    line-height: 0.6rem;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.85);
  }
  .active {
    color: #fff;
    position: relative;
    font-family: DMSans-Bold, DMSans;
    font-weight: bold;
    &::after{
      content: "";
      position: absolute;
      left: 0.3rem;
      right: 0.3rem;
      bottom: 0.15rem;
      height: 2px;
      background: linear-gradient(90deg,#38F4BA 0%, #34DAC5 100%);
    }
  }

}
@media screen and (max-width: 800px) {

}
</style>
